/*
Version 0.140

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2019.

!Changelog

2020
	17-02-2020
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_singlelesson = {};

(function(){
	 
	/*
	PRELOAD & DOCUMENT READY  *****************************************************************
	PRELOAD & DOCUMENT READY  *****************************************************************
	PRELOAD & DOCUMENT READY  *****************************************************************
	PRELOAD & DOCUMENT READY  *****************************************************************
	*/

	this.onready = function() {
			
		/*
		Click
		*/
		$(document).on('click','.js-singlelesson-submit',function() {

			/*
			Set: Active
			*/
			$(this).addClass('active');

			var _date 	= $('.js-singlelesson-date').val();

			if(_date == '') {
					
				/*
				Error: Popup
				*/
				popup.open(1,1,'losse-les-datum');

				/*
				Remove: Active
				*/
				$(this).removeClass('active');

				/*
				Return
				*/
				return false;
			}

			/*
			Check if monday or thursday
			*/
			var _today 	= new Date();
			var day 	= new Date(_date);

			if(
				day.getUTCDay() != 1 &&
				day.getUTCDay() != 4 ||
				day <=_today
			) {

					/*
					Error: Popup
					*/
					popup.open(1,1,'losse-les-datum');

					/*
					Remove: Active
					*/
					$(this).removeClass('active');

			} else {

				/*
				Submit
				*/
				specific_singlelesson.submit(
					_date
				);

			}

		});

	};
	
	/*
	METHODS *****************************************************************
	METHODS *****************************************************************
	METHODS *****************************************************************
	METHODS *****************************************************************
	*/
	
	this.submit = function(
		_date
	) {

		/*
		AJAX
		*/
		$.ajax({
			url: globalUrl + '/a/a/mollie-singlelesson',
			method:'POST',
			data: {
				date: _date
			},
			headers: { 
				'go-load':1 
			},
			success: function(response) {

				/*
				Go to Mollie
				*/
				window.location.href = response;
			  
			}
		});


	};

}).apply(specific_singlelesson); 